import React from 'react';
import Entry from '../entry';
import { Flex, Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = 'Smart Braces';
  const hints = [(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Kent Tinseltooth] </Text><a href="https://www.ericconrad.com/2016/09/deepbluecli-powershell-module-for-hunt.html">Iptables</a></Flex>),
  ];
  const assignment = `OK, this is starting to freak me out!
Oh sorry, I'm Kent Tinseltooth. My Smart Braces are acting up.
Do... Do you ever get the feeling you can hear things? Like, voices?
I know, I sound crazy, but ever since I got these... Oh!
Do you think you could take a look at my Smart Braces terminal?
I'll bet you can keep other students out of my head, so to speak.
It might just take a bit of Iptables work.`;
  const data = useStaticQuery(graphql`
    query {
      cranBraces: file(relativePath: { eq: "cranBraces.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      bradesStart: file(relativePath: { eq: "bradesStart.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      termBracesScreen: file(relativePath: { eq: "termBracesScreen.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      termBracesScript1: file(relativePath: { eq: "termBracesScript1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      bracesWin: file(relativePath: { eq: "bracesWin.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `);
  const extra = (
    <>
    <Img fluid={data.cranBraces.childImageSharp.fluid}
            style={{ margin: 0,  maxHeight: '35vh', width: '72vw' }}
            imgStyle={{ objectFit: 'contain' }}
    />
    <Text mb={1} fontSize='13px' alignSelf='center'>Location: Student Union</Text>

    </>
  );

  return (
    <Entry
      title={title}
      hints={hints}
      extra={extra}
      assignment={assignment}
    >
      <Text mb={2}>The challenge starts by Inner Voice social engineering (?) Kent.</Text>
      <Img fluid={data.bradesStart.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>When we <code>cat</code> the file Kent mentioned, we see the firewall config requirements.</Text>
      <Img fluid={data.termBracesScreen.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>We're going to write a bash script <code>lol.sh</code> with all requirements in the right order.</Text>
      <Img fluid={data.termBracesScript1.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>After running the script Kent's futuristic toothcare device is safe(r).</Text>
      <Img fluid={data.bracesWin.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

    </Entry>
  )

};

// a35972cc5ec5
